<script>
	import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  
	import { activePage } from './../stores.js';

  import toTitleCase from './../transitions/toTitleCase.js'

  import Stepper from './../components/Stepper.svelte'
  import CircularVideo from './../components/CircularVideo.svelte'
  import Footer from './../components/Footer.svelte'
  import Linkbag from './../components/Linkbag.svelte'

	let skipToInstrument = false
  let mounted = false

	onMount( () => {
    mounted = true
	})

</script>

<main>
	<section class="text-section" id="home" in:fade={{ delay: 250, duration: 250 }} out:fade={{ duration: 250 }}>

		<header class="image-bg">
			{#if mounted}
				<h1 in:toTitleCase>VIRTUAL TAIKO</h1>
			{/if}
		</header>
		
		<section>
			<h2>WelcoMe!</h2>
			<p><a href="https://nagatashachu.com">Nagata Shachu Japanese Taiko & Music Group</a> is pleased to share this free online resource hub and virtual taiko to educators, students and the general public.</p>
		</section>

		<section>
			<h2>episodes</h2>
			<p>Learn to play taiko using our virtual drum!
			<br/><span class="small">(Works on Safari or Chrome on computers, smartphones, and tablets — not tested on Firefox)</span></p>
			<ol class="plain" id="episodes">
				<li><a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page:"instrument", episode: 1})
					}}>Episode 1: Raijin, the God of Thunder</a></li>
				<li><a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page:"instrument", episode: 2})
					}}>Episode 2: Benten, the Goddess of Art</a></li>
				<li><a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page:"instrument", episode: 3})
					}}>Episode 3: Fūjin, the Goddess of Wind</a></li>
		</section>

		<section>
			<h2>Video perforMAnce</h2>
			<p>Watch Nagata Shachu's immersive 360 degree performance: <br/>
				<a href="https://www.youtube.com/nagatashachu">Watch on YouTube (supports VR headsets)</a>
			</p>
		</section>
        
		<section>
			<h2>Augmented Reality poster</h2>
			<p>Learn the stories of Nagata Shachu members and their instruments through this 
			<a href="https://nagatashachu.com/stories/assets/p/ARPoster_NS_Informative11x17.pdf">AR Poster</a> 
			created by <a href="https://collective-cam.carrd.co/">CAM Collective.</a>
			</p>
		</section>
		
		<section>
			<h2>bonus MateriAls</h2>
			<p class="mb-0">Still want more? Check out these other exclusive performance videos, documentaries, and resources.</p>
			<details>
				<summary>Tap for more!</summary>
				<Linkbag />
			</details>
		</section>
    
		<section class="mb-1">
      <h2>naViGation</h2>
      <ol class="plain">
				<li>
					<a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page: "event"})
					}}>Event</a>
				</li>
				<li>
					<a href="#" on:click={ e => {
						e.preventDefault()
						e.stopPropagation()
						activePage.set({page: "instrument"})
					}}>Instrument</a>
				</li>
			</ol>
    </section>
		
		<Footer />
	
	</section>
</main>

<style>
	#episodes {
		margin-top: 0.5rem;
	}
  
  section.mb-1 {
    margin-bottom: 1.15rem;
  }
</style>